<h1 mat-dialog-title>
  Edit {{program.type | titlecase}} Bonus Program
</h1>
<div mat-dialog-content>
    <form class="form" *ngIf="form" [formGroup]="form" padding>
            <mat-form-field>
                <mat-label>Amount to send ($)</mat-label>
                <input type="number" matInput placeholder="" formControlName="amount">
            </mat-form-field>
            <div class="textfield">
                <span class="textfieldtitle">Message</span>
                <textarea formControlName="message"></textarea>
            </div>
    </form>
</div>
<div class="buttons" mat-dialog-actions>
    <button mat-raised-button [disabled]="!form.valid" class="donebutton" color="primary" (click)="okClicked()">OK</button>
    <button mat-button (click)="onDismiss()">Cancel</button>
</div>
